import React from 'react';
import Link from 'next/link';

export default ({ to, children, ...props }) => (!to ? null : <Link passHref={true} href={to}><a {...props}>{children}</a></Link>);
